import '../../../styles/pages/Qr-view.scss';

import { Selection } from "d3";
import { IGroup, IResultQR } from '../../data/models/Entities';
import { _SvGrupoEscanearQr, _SvGrupoRechazarEntrada, _SvGrupoSalidaEscuela } from "../../data/services/GrupoEscuela";
import { _HistoryBack } from '../../routes/UIManager';
import { SCANED_QR_VALUE } from '../../utils/Device';
import _L, { _HttpMsg } from '../../utils/Labels';
import { Base } from "../bases/Base";
import { LOADING } from '../components/Loading';
import ic_bubble_qr from '/icons/ic_bubble_qr.svg?raw';
import ic_bubble_qr_error from '/icons/ic_bubble_qr_error.svg?raw';
import ic_logo_sad from '/icons/ic_logo_sad.svg';
import ic_exit from '/icons/ic_exit.svg';
import { _APP_DATA } from '../../data/AppData';
import { _GRUPO_MAESTROSINFO_MAP } from '../../data/services/Grupo';
import { _SvGrupoEntrada } from '../../data/services/GrupoClase';
import { ShowToast } from '../components/Toast';
import { _SvUsuarioObtenerGrupos } from '../../data/services/Usuario';
import { _SvAlumnoObtenerHorarioHoy } from '../../data/services/Alumno';
import { AvatarAlumnoComponent } from '../components-lit/AvatarAlumno/AvatarAlumno';
import { CheckBox } from '../components/CheckBox';

type IAlumnoInfo = IResultQR["InfoAlumno"];
export class QRView extends Base {

    private divMain?: Selection<HTMLDivElement, any, any, any>;
    private avatarAlumno?: AvatarAlumnoComponent;

    constructor() {
        super('qr-view', true);

        if (!SCANED_QR_VALUE) {
            _HistoryBack();
            return
        };

        LOADING.Show();
        this.CreateLoginUI();

        this.OnScanQR();
    }

    private OnScanQR() {
        _SvGrupoEscanearQr(SCANED_QR_VALUE, (result: IResultQR) => {
            this.UpdateFromResponse(result);
            LOADING.Dismiss();
        });
    }

    private CheckInGroup(infoAlumno: IAlumnoInfo, infoGrupo: IGroup) {
        return new Promise<void>((res) => {
            _SvGrupoEntrada(infoAlumno.IdChild, infoGrupo.IdGrupo, (status) => {
                const title = _L("classroom.entraa_grupo_title");
                if (status !== 1 && status !== -1) {
                    ShowToast(title, _HttpMsg("grupo/Entrada", status) + ". " + _L("general.user_reintent"), "error");
                    LOADING.Dismiss();
                    res();
                    return;
                }

                if (status === -1) {
                    ShowToast(title, _HttpMsg("grupo/Entrada", status), "info");
                    LOADING.Dismiss();
                    res()
                    return;
                }

                ShowToast(title, _L("classroom.alumno_llego_g", infoAlumno.Nombre), "success");
                res();
            })
        })
    }

    public CreateLoginUI() {
        const headerContainer = this.mainContainer.append("div").classed("header", true);
        headerContainer.append("img")
            .attr("src", ic_exit)
            .classed("img-exit", true)
            .attr("alt", "close-icon")
            .on("click", () => {
                _HistoryBack();
            });

        // const mainContainer = select("body");
        this.divMain = this.mainContainer.append("div").classed("container", true)

        this.ShowAvatar();

        this.divMain.append("h2").classed("title", true);

        this.divMain.append("h2").classed("cfg_description", true);

        this.divMain.append("h2").classed("description", true);


        this.divMain.append("div").classed("enter-classroom-container", true);
        const btnLoggin = this.divMain.append("button")
            .attr("type", "button")
            .classed("btn-confirm-qr", true)
            .style("display", "none")
            .text(_L("general.acepta").toUpperCase());


        btnLoggin.on("click", () => {
            _HistoryBack();
        });
    }

    private ShowAvatar() {
        this.avatarAlumno = new AvatarAlumnoComponent()
        this.avatarAlumno.k_width = "180px";
        this.avatarAlumno.k_height = "180px";
        this.avatarAlumno.k_defaultAvatarSVG = ic_bubble_qr;

        // Mientras se traen  los datos del alumno
        this.avatarAlumno.k_src = null;
        this.avatarAlumno.k_alumno = null;
        this.avatarAlumno.k_maxBorderWidth = 0;
        this.avatarAlumno.k_colorBorder = 'transparent'
        this.avatarAlumno.style.backgroundColor = 'transparent';

        const imgContainer = this.divMain.append("div").classed("img-container", true);
        imgContainer.node().appendChild(this.avatarAlumno);
        imgContainer.append("img").classed("img-mask hide", true).attr("src", ic_logo_sad);
    }

    private UpdateFromResponse(response: IResultQR) {
        const { Accion, Resultado, InfoAlumno, IdCategoria, IdGrupo, Descripcion } = response;
        this.avatarAlumno.k_defaultAvatarSVG = Resultado > 0 ? ic_bubble_qr : ic_bubble_qr_error;
        if (!!InfoAlumno && InfoAlumno.IdChild) {
            this.avatarAlumno.k_defaultAvatarSVG = null;
            this.avatarAlumno.style.backgroundColor = null;
            this.avatarAlumno.k_minBorderWidth = 8;
            this.avatarAlumno.k_maxBorderWidth = 8;
            this.avatarAlumno.k_colorBorder = Resultado > 0 ? null : 'var(--color-error)';
            this.avatarAlumno.k_alumno = InfoAlumno;
            this.divMain.select(".img-container .img-mask").classed("hide", Resultado > 0);
        }

        const category = [
            _L("modulo.E/S"),
            _L("E/S.entrada"),
            _L("E/S.salida"),
        ][IdCategoria];

        let actionText = Accion == 1
            ? _L("E/S.entrada")
            : Accion == 2
                ? _L("E/S.salida")
                : category;

        const enterClassroomContainter = this.divMain.select<HTMLDivElement>(".enter-classroom-container");
        enterClassroomContainter.selectAll("*").remove();
        enterClassroomContainter.classed("hide", true);

        this.divMain.select(".title").text(actionText);
        const description = this.GetMessageDescription(response);
        this.divMain.select(".description").classed("err", Resultado < 1);
        this.divMain.select(".description").text(description);
        this.divMain.select(".cfg_description").classed("hide", true);
        const btnConfirm = this.divMain.select<HTMLButtonElement>(".btn-confirm-qr").style("display", "block")

        if (!InfoAlumno || InfoAlumno.IdChild < 1) return;
        this.divMain.select(".title").text(`${InfoAlumno.Nombre} ${InfoAlumno.ApPaterno} ${InfoAlumno.ApMaterno}`)
        this.divMain.select(".cfg_description").classed("hide", !Descripcion).text(Descripcion);
        this.divMain.select(".description").text(`${actionText}${Resultado < 1 ? `: ${description}` : ''}`)

        if (Resultado < 1 || Accion !== 1 || !IdGrupo || !InfoAlumno || !InfoAlumno.IdChild) return;
        btnConfirm.on("click", null);
        LOADING.Show();
        _SvUsuarioObtenerGrupos((groups) => {
            LOADING.Dismiss();
            const grupoEntrada = groups.find(d => d.IdGrupo == IdGrupo);
            if (!grupoEntrada) {
                console.warn("-d", "No se encontró el grupo dentro de los grupos del usuario");
                btnConfirm.on("click", () => {
                    _HistoryBack();
                });
                return;
            };

            enterClassroomContainter.classed("hide", false);

            const checkEnterClassroom = new CheckBox(enterClassroomContainter)
                .SetIdentifier("enter")
                .SetLabel(_L("classroom.entrada_classroom"))
                .SetValue(false);

            btnConfirm.on("click", async () => {
                if (!checkEnterClassroom.IsChecked()) {
                    _HistoryBack();
                    return;
                }
                LOADING.Show();
                await this.CheckInGroup(InfoAlumno, grupoEntrada);
                LOADING.Dismiss();
                _HistoryBack();
            });

            this.divMain.select(".description").text(`${_L("E/S.entraa_grupo")}: ${grupoEntrada.NombreGrupo}`)
        })
    }

    private GetMessageDescription(result: IResultQR): string {
        if (result?.Resultado > 0) {
            return result.Descripcion;
        }
        return _HttpMsg("grupo/EscanearQr", result?.Resultado || -111);
    }
}